import { takeLatest } from "redux-saga/effects";
import {
	handleGetProviderCategory,
	handleGetProviderSearchData,
} from "./handlers/provider";
import { 
	 GET_PROVIDER_DATA,
	 GET_PROVIDER_CATEGORIES, 
} from "../duck/provider";

import {
	VERIFY_CODE,
	CREATE_USER,
	REQUEST_LOGIN
} from "../duck/auth";

import {
	handleRequestLogin,
	handleVerifyCode,
	handleCreateUser
} from "./handlers/auth"

// all of the of the watcher would go here
export function* watcherSaga() {

	//provider
	yield takeLatest(GET_PROVIDER_DATA, handleGetProviderSearchData);
	yield takeLatest(GET_PROVIDER_CATEGORIES, handleGetProviderCategory);


	// auth and account
	yield takeLatest(REQUEST_LOGIN, handleRequestLogin)
	yield takeLatest(VERIFY_CODE, handleVerifyCode)
	yield takeLatest(CREATE_USER, handleCreateUser)
}
